import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export default function Dashboard() {
  const navigate = useNavigate();
  const { user, clearAuth } = useAuthStore();

  /**
   * Handle logout
   */
  const handleLogout = () => {
    clearAuth();
    navigate('/', { replace: true });
  };

  /**
   * Navigate to create session (host)
   */
  const handleHostSession = () => {
    navigate('/create-session');
  };

  /**
   * Navigate to join session (listener)
   */
  const handleJoinSession = () => {
    navigate('/join');
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Silent Disco</h1>
        <div className="user-info">
          <span className="user-name">Welcome, {user?.displayName || 'User'}!</span>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </header>

      <main className="dashboard-main">
        <h2>What would you like to do?</h2>
        
        <div className="action-cards">
          <div className="action-card">
            <div className="card-icon">🎧</div>
            <h3>Host a Session</h3>
            <p>
              Create and broadcast your own audio stream to listeners.
              Control the session and manage your audience.
            </p>
            <button 
              onClick={handleHostSession}
              className="primary-button"
            >
              Start Hosting
            </button>
          </div>

          <div className="action-card">
            <div className="card-icon">🎵</div>
            <h3>Join a Session</h3>
            <p>
              Enter a passcode or use an invitation link to join
              an existing streaming session as a listener.
            </p>
            <button 
              onClick={handleJoinSession}
              className="primary-button"
            >
              Join Session
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
